// 难度选择弹窗
import CustomPopup from "../../../../components/CustomPopup";
import React, {useContext} from "react";
import './HintDialog.css'
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";

interface Props {
    isOpen: boolean,
    onClose: () => void,
    hintText?: string
}

// 显示UGC详细Hint的弹窗
const HintDialog: React.FC<Props> = ({
                                                         isOpen,
                                                         onClose,
                                                         hintText,
                                                     }) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="hint-modal-container">
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                     alt="pic"/>
                {/*标题*/}
                <div
                    className="font-size-16 my-roboto-bold text-center margin-top-11 height-26 display-flex-row display-flex-justify-content-center display-flex-align-items-center">
                    Hint
                    <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="exit-close-btn"
                         alt="pic"/>
                </div>
                {/*内容*/}
                <div
                          className={`hint-content-container padding-all-14 margin-top-auto margin-bottom-20 my-roboto-regular width-260 min-height-144 bg-color-grey-input border-radius-5 margin-left-right-auto display-flex-row display-flex-justify-content-center`}>
                    {hintText}
                </div>

            </div>
        </CustomPopup>
    )
}

export default HintDialog;